import { render, staticRenderFns } from "./course_myanswer.vue?vue&type=template&id=e50698d2&scoped=true&"
import script from "./course_myanswer.vue?vue&type=script&lang=js&"
export * from "./course_myanswer.vue?vue&type=script&lang=js&"
import style0 from "./course_myanswer.vue?vue&type=style&index=0&id=e50698d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50698d2",
  null
  
)

export default component.exports